/* eslint-disable react/no-unescaped-entities */
import { Container } from 'src/core/ds/container'
import { useCurrentAccount } from 'src/entities/account/useCurrentAccount'
import { FeatureModal } from 'src/entities/subscription/FeatureModal'
import { useAnalytics } from 'src/hooks/useAnalytics'
import { AppLayout } from 'src/layouts/AppLayout'
import { Footer } from 'src/layouts/Footer'
import { PricesPicogen } from '../prices/PricesPicogen'
import styles from './index.module.scss'
import { Blog } from './parts/Blog'
import { Faq } from './parts/Faq'
import { Features } from './parts/Features'
import { Hero } from './parts/Hero'
import { Testimonials } from './parts/Testimonials'
import { Upsell } from './parts/Upsell'

declare global {
  interface Window {
    cfToken: string
    plausible: any
  }
}

export function LandingScreen() {
  const { data: currentUser } = useCurrentAccount()
  useAnalytics()

  return (
    <AppLayout>
      <div className={styles.surface}>
        <Hero currentUser={currentUser} />
      </div>
      <Container>
        <Features />

        {/* <Comparison /> */}

        <section className={styles.cost}>
          <PricesPicogen showFree={false} />
        </section>

        <Testimonials />

        <Blog />

        <Faq />

        <Upsell />
        <FeatureModal />
      </Container>
      <Footer />
    </AppLayout>
  )
}
